<div style="display: flow; width: 75vw;">
    <h2>Criterios de Tareas</h2>
    <div class="left">
        <h3>Criterios
            <button mat-icon-button aria-label="" (click)="onCreateCriteria()">
                <mat-icon>add</mat-icon>
            </button>
        </h3>

        <!-- Criteria -->
        <table>
            <caption></caption>
            <thead>
                <tr>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>

                <!-- Criterios list -->
                <tr *ngFor="let option of criteriosList" (click)="selectCriteria(option.value)"
                    [ngClass]="{ 'selected' : selectedCriteria === option.value }">
                    <td>{{option.viewValue}}</td>
                    <td>
                        <button mat-icon-button aria-label="" (click)="onUpdateCriteria(option)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button aria-label="" (click)="onDeleteCriteria(option.value)">
                            <mat-icon>delete_forever</mat-icon>
                        </button>
                    </td>
                </tr>

        </table>
    </div>

    <!-- Rules -->
    <div class="right criterios-table">
        <h3>Reglas
            <button mat-icon-button aria-label="" (click)="onCreateRule()">
                <mat-icon>add</mat-icon>
            </button>
        </h3>

        <!-- Loader -->
        <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate" *ngIf="rulesAreLoading">
        </mat-progress-spinner>

        <table class="task-rules-tbl" *ngIf="!rulesAreLoading">
            <caption></caption>
            <!-- Rules headers -->
            <thead>
                <tr>
                    <th>Prioridad</th>
                    <th>Regla</th>
                    <th>Parametro </th>
                    <th></th>
                    <th>Parametro2 </th>
                    <th></th>
                    <th>Tarea</th>
                    <th>Dias</th>
                    <th></th>
                </tr>
            </thead>

            <!-- Rules of selected criteria -->
            <tbody>
                <tr *ngFor="let ruleForm of rulesForms.controls" [formGroup]="ruleForm">
                    <td>
                        <mat-form-field class="example-full-width" appearance="fill">
                            <input matInput formControlName="prioridad">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field appearance="fill">
                            <mat-select formControlName="tipoReglaId" (onchange)="onRuleTypeChanges(ruleForm)">
                                <mat-option *ngFor="let option of ruleTypes" [value]="option.tipoReglaId">
                                    {{option.regla}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-error *ngIf="ruleForm.controls.tipoReglaId.errors">
                            Obligatorio
                        </mat-error>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width" appearance="fill">
                            <input matInput formControlName="parametro1" readonly>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width" appearance="fill">
                            <input matInput formControlName="param1" type="number"
                                [ngClass]="{ 'hide' : ruleForm.controls.param1.disabled }">
                        </mat-form-field>
                        <mat-error *ngIf="ruleForm.controls.param1.errors">
                            Obligatorio
                        </mat-error>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width" appearance="fill">
                            <input matInput formControlName="parametro2" readonly>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width" appearance="fill">
                            <input matInput formControlName="param2" type="number"
                                [ngClass]="{ 'hide' : ruleForm.controls.param2.disabled }">
                        </mat-form-field>
                        <mat-error *ngIf="ruleForm.controls.param2.errors">
                            Obligatorio
                        </mat-error>
                    </td>
                    <td>
                        <mat-form-field appearance="fill">
                            <mat-select formControlName="tareaId">
                                <mat-option [value]="1">Contacto</mat-option>
                                <mat-option [value]="2">Citar</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-error *ngIf="ruleForm.controls.tareaId.errors">
                            Obligatorio
                        </mat-error>
                    </td>
                    <td>
                        <mat-form-field class="example-full-width" appearance="fill">
                            <input matInput formControlName="dias" type="number">
                        </mat-form-field>
                        <mat-error *ngIf="ruleForm.controls.dias.errors">
                            El máximo de días es 30
                        </mat-error>
                    </td>
                    <td>
                        <button mat-icon-button aria-label="" (click)="onDeleteRule(ruleForm)">
                            <mat-icon>delete_forever</mat-icon>
                        </button>
                        <button mat-icon-button aria-label="" (click)="onUpdateRule(ruleForm)">
                            <mat-icon>save</mat-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="popoup-footer">
        <button class="cancel" (click)="onClose()"><span class="mat-button-wrapper">Cancelar</span></button>
    </div>
</div>
